export const FIREFLY_ROLES = {
  VISITOR: 'visitor',
  CUSTOMER: 'customer',
  ADMIN: 'admin'
}

// Legacy aliases are accepted only to migrate old records into the current
// three-state contract. Do not create new product roles from this list.
const ADMIN_ROLE_ALIASES = new Set(['admin', 'super_admin', 'manager', 'staff', 'owner'])
const CUSTOMER_ROLE_ALIASES = new Set(['customer', 'user', 'viewer', 'member'])

export function normalizeRoleValue(role, { authenticated = false } = {}) {
  if (typeof role !== 'string' || !role.trim()) {
    return authenticated ? FIREFLY_ROLES.CUSTOMER : FIREFLY_ROLES.VISITOR
  }

  const value = role.trim().toLowerCase()

  if (ADMIN_ROLE_ALIASES.has(value)) {
    return FIREFLY_ROLES.ADMIN
  }

  if (CUSTOMER_ROLE_ALIASES.has(value)) {
    return FIREFLY_ROLES.CUSTOMER
  }

  if (value === FIREFLY_ROLES.VISITOR) {
    return authenticated ? FIREFLY_ROLES.CUSTOMER : FIREFLY_ROLES.VISITOR
  }

  return authenticated ? FIREFLY_ROLES.CUSTOMER : FIREFLY_ROLES.VISITOR
}

export function normalizeAuthenticatedRole(role) {
  return normalizeRoleValue(role, { authenticated: true })
}

export function isAdminRole(role) {
  return normalizeRoleValue(role, { authenticated: true }) === FIREFLY_ROLES.ADMIN
}

export function parseEmailList(value) {
  return String(value || '')
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)
}

export function collectAuthUserEmails(user) {
  const emails = new Set()
  if (!user) return emails

  const addEmail = (value) => {
    if (!value) return
    const normalized = String(value).trim().toLowerCase()
    if (normalized) {
      emails.add(normalized)
    }
  }

  addEmail(user.email)

  const metadata = user.user_metadata || {}
  addEmail(metadata.email)
  addEmail(metadata.backupEmail)
  addEmail(metadata.backup_email)

  if (Array.isArray(metadata.additionalEmails)) {
    metadata.additionalEmails.forEach(addEmail)
  }

  if (Array.isArray(metadata.additional_emails)) {
    metadata.additional_emails.forEach(addEmail)
  }

  if (Array.isArray(user.identities)) {
    user.identities.forEach((identity) => {
      addEmail(identity?.identity_data?.email)
    })
  }

  return emails
}

export function hasAllowListAccess(user, allowList) {
  if (!Array.isArray(allowList) || !allowList.length) return false
  const emails = Array.from(collectAuthUserEmails(user))
  return emails.some((email) => allowList.includes(email))
}
